export const gameList = [
  {
    name: "Саванна",
    route: "/startgame/savanna/book",
  },
  {
    name: "Аудиовызов",
    route: "/startgame/audiocall/book",
  },
  {
    name: "Карточки",
    route: "/startgame/memory/book",
  },
  {
    name: "Спринт",
    route: "/startgame/sprint/book",
  },
];

export const gameListDeleted = [
  {
    name: "Саванна",
    route: "/startgame/savanna/deleted",
  },
  {
    name: "Аудиовызов",
    route: "/startgame/audiocall/deleted",
  },
  {
    name: "Карточки",
    route: "/startgame/memory/deleted",
  },
  {
    name: "Спринт",
    route: "/startgame/sprint/deleted",
  },
];

export const gameListСompound = [
  {
    name: "Саванна",
    route: "/startgame/savanna/compound",
  },
  {
    name: "Аудиовызов",
    route: "/startgame/audiocall/compound",
  },
  {
    name: "Карточки",
    route: "/startgame/memory/compound",
  },
  {
    name: "Спринт",
    route: "/startgame/sprint/compound",
  },
];